import {
  browserName,
  browserVersion,
  isMobile,
  mobileModel,
  mobileVendor,
  osName,
  osVersion,
} from "mobile-device-detect";
import parser from "ua-parser-js";
export const getUserBrowser = () => {
  return browserName + " " + browserVersion;
};

export const getUserOS = () => {
  return osName + " " + osVersion;
};

export const getDeviceModel = () => {
  const parserInstance = new parser();
  if (isMobile) {
    const device = parserInstance.getDevice();
    return typeof device.vendor === "undefined" || device.model.length <= 1
      ? null
      : device.vendor + " " + device.model;
  } else {
    return osName + " " + osVersion;
  }
};
